import React, { useEffect } from 'react';

import { WorkflowEntity } from '../../workflow/Workflow.interface';
import { useFindWorkflowVersionByEntity } from '../../workflow/Workflow.hooks';
import WorkflowStatusSelector, {
  WorkflowStatusSelectorProps
} from '../../workflow/components/WorkflowStatusSelector';

export type DocumentStatusFilterProps = Pick<
  WorkflowStatusSelectorProps,
  'value' | 'onChange'
>;

const DocumentStatusFilter: React.FC<DocumentStatusFilterProps> = (
  props: DocumentStatusFilterProps
) => {
  const { workflowVersion, isLoading, loadingError, findWorkflowVersion } =
    useFindWorkflowVersionByEntity(WorkflowEntity.File);

  useEffect(() => {
    findWorkflowVersion();
  }, [findWorkflowVersion]);

  return (
    <WorkflowStatusSelector
      {...props}
      error={loadingError}
      isLoading={isLoading}
      workflowVersion={workflowVersion}
      textFieldProps={{ label: undefined, placeholder: 'Select Status' }}
    />
  );
};

export default DocumentStatusFilter;
